import React, { useState, useEffect } from 'react';
import { frontend } from 'pageflow-scrolled/frontend';

function AlmanacRibbon() {
  const [data, setData] = useState([]);
  const [expandedYear, setExpandedYear] = useState(null);

  useEffect(() => {
    fetch('/almanac_entry_metadata/almanac_ribbon.json')
      .then((res) => res.json())
      .then((json) => setData(json))
      .catch((err) => console.error('Failed to load almanac ribbon data', err));
  }, []);

  // Tags each chapter's first content section (the one immediately after its
  // heading) with 'essay-opener', so the drop-cap CSS can target only the
  // essay's true opening paragraph instead of every section's first letter.
  // Runs independently of the ribbon's own data/render logic above.
  useEffect(() => {
    function tagFirstParagraphs() {
      const nodes = Array.from(
        document.querySelectorAll(
          '[class*="Heading-module_root"], [class*="Text-module_body"]'
        )
      );
      nodes.sort((a, b) => {
        const pos = a.compareDocumentPosition(b);
        if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
        if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
        return 0;
      });

      let expectingOpener = false;
      nodes.forEach((node) => {
        const isHeading = node.className.includes('Heading-module_root');
        const isTextBlock = node.className.includes('Text-module_body');
        if (isHeading) {
          expectingOpener = true;
        } else if (isTextBlock && expectingOpener) {
          node.classList.add('essay-opener');
          expectingOpener = false;
        }
      });
    }

    tagFirstParagraphs();
    const observer = new MutationObserver(tagFirstParagraphs);
    observer.observe(document.body, {childList: true, subtree: true});
    return () => observer.disconnect();
  }, []);

  function toggleYear(year) {
    setExpandedYear(expandedYear === year ? null : year);
  }

  const seasonOrder = ['Spring', 'Summer', 'Autumn', 'Winter'];

  return (
    <div className="almanacRibbon">
      <ul className="almanacRibbon-years">
        {data.map((yearEntry) => (
          <li key={yearEntry.year} className="almanacRibbon-yearItem">
            <button
              className="almanacRibbon-yearButton"
              onClick={() => toggleYear(yearEntry.year)}
              aria-expanded={expandedYear === yearEntry.year}
            >
              {yearEntry.year}
            </button>
          </li>
        ))}
      </ul>
      {data.map((yearEntry) =>
        expandedYear === yearEntry.year ? (
          <div key={yearEntry.year} className="almanacRibbon-panel">
            {seasonOrder
              .filter((season) => yearEntry.seasons.some((s) => s.season === season))
              .map((season) => {
                const seasonEntry = yearEntry.seasons.find((s) => s.season === season);
                const firstEntry = seasonEntry.entries[0];
                return (
                  <a
                  
                    key={season}
                    className="almanacRibbon-quarter"
                    href={firstEntry ? '/' + firstEntry.permalink : '#'}
                  >
                    {season}
                  </a>
                );
              })}
          </div>
        ) : null
      )}
    </div>
  );
}

frontend.widgetTypes.register('almanacRibbon', {
  component: AlmanacRibbon
});
